import { useEffect, useState } from "react"
import ToDoList from "./ToDoList";
import Notepad from "./Notepad";
import { Pencil } from 'lucide-react';
import { useLocation } from "react-router-dom";
import { useSingleProject, updateSingleProject } from "../../hooks/db";
import { Link } from "react-router-dom";
import Tracks from "./Tracks";
import Comments from "./Comments";
import { set } from "rsuite/esm/internals/utils/date";
import { Loader } from "lucide-react";
import { useUserClients } from "../../hooks/db";
import serverURL from "../../config/serverConfig";

const Project = (props) => {

    //get project id from link state
    const location = useLocation(); 
    const projectID = location.state.project_id; 
    // console.log("Project ID: ", projectID)

    //initialize project detail states
    const [project, setProject] = useState(null);
    const [tempProject, setTempProject] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [daysTilDue, setDaysTilDue] = useState(null);

    const [editing, setEditing] = useState(false)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteText, setDeleteText] = useState("");
    const [showReassignDialog, setShowReassignDialog] = useState(false);
    //const [clients, setClients] = useState();
    const clients = useUserClients(project ? project.user_id : null);
    const [selectedClient, setSelectedClient] = useState({name: "", client_id: null})
    console.log("clients = ", clients)

    //use custom hook to fetch project details
    let fetchedProject = useSingleProject(projectID);

    //Format fetched project fee and paid amounts to numbers
    useEffect(() => {
        if (fetchedProject && fetchedProject[0]){
            let formattedFetchedProject = fetchedProject[0];

            let fee = formattedFetchedProject.fee && typeof formattedFetchedProject.fee === 'string' ? formattedFetchedProject.fee.replaceAll("$", "") : null;
            let feeNumber = fee ? Number(fee) : null;
            formattedFetchedProject.fee = feeNumber;

            let paid = formattedFetchedProject.paid && typeof formattedFetchedProject.paid === 'string' ? formattedFetchedProject.paid.replaceAll("$", "") : null;
            let paidNumber = paid ? Number(paid) : null;
            formattedFetchedProject.paid = paidNumber;

            setProject(formattedFetchedProject)
            setTempProject(formattedFetchedProject);
            //{clients && project ? clients.find(c => c.client_id === project.client_id)?.name : "Loading..."}
            setSelectedClient({name: formattedFetchedProject.client, client_id: Number(formattedFetchedProject.client_id)})
            console.log("Fetched Project: ", formattedFetchedProject)
        }
    },[fetchedProject])

    // Format due date and start date for local time zone display
    useEffect(() => {
        if (project) {
            var offset = new Date().getTimezoneOffset();
            var offset_ms = offset * 60000

            let due_date = new Date(Date.parse(project.due_date)+offset_ms);
            setDueDate(due_date.toLocaleDateString())

            let start_date = new Date(Date.parse(project.start_date)+offset_ms);
            setStartDate(start_date.toLocaleDateString());

            let today = Date.now()-offset_ms;
            console.log((due_date - today)/86400000)
            setDaysTilDue(Math.round((due_date - today)/86400000));
        }
    },[project])

    // Toggle editing mode and save changes if necessary
    const toggleEditing = () => {
        if (editing) {
            if (project !== tempProject) {
                console.log("Saving project changes...")
                console.log("Temp Project: ", tempProject)
                updateProject(tempProject);
            }
        }
        setEditing(!editing);
    }

    // Update project data and upload to server
    const updateProject = async (updatedProject) => {
        setProject(updatedProject)
        //validdate data format first

        try {
            await updateSingleProject(updatedProject.project_id, updatedProject);
        } catch (err) {
            console.error("Error updating project: ", err);
            return;
        } finally {
            console.log("Updating project...");
        }
    }

    const loadClients = async () => {
       fetch(`${serverURL}getUserClients`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id: project.user_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                console.log("Fetched clients:", jsonData);
                //setClients(jsonData);
            })
            .catch(error => {
                console.error("Error fetching clients:", error);
            });
    }

    const displayName = clients && project ? clients.find(c => c.client_id === project.client_id)?.name : "Loading...";


    if (project) {
        return (
            <div className="m-auto pt-6 px-10 max-w-[1200px] flex flex-col self-center relative h-full">
                <div id="projectTitleRow" className="mb-[15px]">
                    <div className="flex">
                        {editing?
                        <div className="flex flex-col uppercase font-semibold">
                            <div className="text-xs text-[#ffee00]">Title</div>
                            <textarea
                                className="text-sm rounded-md h-[20px] pl-1 w-[100px] font-semibold mr-1"
                                defaultValue={project.title}
                                onChange={(e)=>setTempProject({ ...project, title: e.target.value })}
                            />
                        </div>
                        :
                            <>"{project.title}" -&nbsp;</>
                        }
                        <span className="text-[#ffee00] text-base uppercase font-bold">

                        <Link
                            to="/Client"
                            state={{ client_id: project.client_id }}
                            key={project.client_id}
                            className="hoverUp"
                        >
                            {/* {project.client} */}
                               {/* find client name from clients list using project.client_id */}
                                {/* {clients && project ? clients.find(c => c.client_id === project.client_id)?.name : "Loading..."} */}
                                {displayName}
                        </Link>

                        </span>
                    </div>
                    <div>
                        <button id ="editButton" onClick={()=>{toggleEditing()}}><Pencil size={18}/></button>
                    </div>
                </div>
                <div id="projectDetailsRow" className="gradientBG">
                    <div className="projectSectionHeader">
                        PROJECT DETAILS
                    </div>
                    <div id="projectDetails">
                        <form id="projectStatus">
                            <span>Status : </span>
                            <select 
                                defaultValue={project.status}
                                onChange={(e)=>updateProject({ ...project, status: e.target.value })}
                            >
                                <option value="Not Started">Not Started</option>
                                <option value="Awaiting Assets">Awaiting Assets</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Awaiting Feedback">Awaiting Feedback</option>
                                <option value="Revising">Revising</option>
                                <option value="Mastering">Mastering</option>
                                <option value="Delivering">Delivering</option>
                                <option value="Complete">Complete</option>
                            </select>
                        </form>

                        <div id="paymentDetails">
                            <div id="projectFee">
                                {editing ?
                                    <div className="flex">
                                    <div className="text-[#ffee00] uppercase font-bold">Fee:&nbsp;</div>$
                                        <input
                                            className="w-[50px] ml-1"
                                            type="number"
                                            defaultValue={project.fee}
                                            onChange={(e)=>setTempProject({ ...project, fee: e.target.value })}
                                        />
                                    </div>
                                :
                                    <><span>Fee : $</span>{project.fee}</>
                                }
                            </div>
                            <div id="projectPaid">
                                {editing ?
                                    <div className="flex">
                                        <div className="text-[#ffee00] uppercase font-bold">Paid:&nbsp;</div>$
                                        <input
                                            className="w-[50px] ml-1"
                                            type="number"
                                            defaultValue={project.paid}
                                            onChange={(e)=>setTempProject({ ...project, paid: e.target.value })}
                                        />
                                    </div>
                                :
                                    <><span>Paid : $</span>{project.paid}</>
                                }
                            </div>
                        </div>
                        <div id="projectDates">
                            <div>
                                <span>Started : </span>{startDate}
                            </div>
                            <div id="projectDueDate">
                                {editing ?
                                    <>
                                        <span className="text-[#ffee00] uppercase font-bold">Due:&nbsp;</span>
                                        <input
                                            className="w-[100px] ml-1"
                                            type="date"
                                            defaultValue={(project.due_date).slice(0, 10)}
                                            onChange={(e)=>setTempProject({ ...project, due_date: e.target.value })}
                                        />
                                    </>
                                :
                                    <>
                                        <span>Due : </span> {dueDate}
                                        {daysTilDue < 0 ?
                                            <sup className="ml-2 px-1 font-bold rounded bg-red-600">
                                                {Math.abs(daysTilDue)} days past due
                                            </sup>
                                            :
                                            daysTilDue != 0 ?
                                                <sup className="ml-2 font-bold">
                                                    in {daysTilDue} days
                                                </sup>
                                                :
                                                <sup className="ml-2 px-1 font-bold rounded bg-orange-500">
                                                    due today
                                                </sup>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div id="projectOffice" className="w-full">
                    <div className="row2 w-full flex flex-col md:grid grid-cols-2 gap-[15px]">
                        <div className="projectPageTray gradientBG">
                            <Notepad projectID={project.project_id} />
                        </div>
                        <div className="projectPageTray gradientBG min-h-[100px]">
                            <ToDoList project_id={project.project_id}/>
                        </div>
                    </div>
                </div>
                <div id="footer" className="absolute left-0 bottom-1 px-10 w-full max-w-full justify-self-end">
                    <div className="flex flex-row justify-between">
                        <button className="mt-6 px-2 py-1 bg-black text-xs text-[#ffee00] rounded hoverUp hover:bg-[#161616]"
                            onClick={() => {
                                loadClients();
                                setShowReassignDialog(true)
                            }}
                        >
                            Reassign Project
                        </button>
                        <button className="mt-6 px-2 py-1 bg-black text-xs text-red-500 rounded hoverUp hover:bg-[#161616]">
                            Delete Project
                        </button>
                    </div>
                </div>
                {showReassignDialog && (
                    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                        <div className=" w-[50vH] h-[50vw] flex flex-col rounded-lg glassBackBlack fixed inset-0 m-auto">
                            <div> 
                                {displayName}
                             
                            </div>
                            <div>
                                {clients ? 
                                <>
                                    {clients.length}
                                    <div>
                                    <label htmlFor="clientDropdown">Choose an option:</label>
                                    <select id="clientDropdown" 
                                        value={selectedClient.name} 
                                        onChange={(e)=>{
                                            const selectedClientId = Number(e.target.value);
                                            const client = clients.find(c => c.client_id === selectedClientId);
                                            if (client) {
                                                setSelectedClient({ name: client.name, client_id: Number(client.client_id) });
                                            }
                                        }}
                                    >
                                        <option value="">--Please choose an option--</option>
                                        {/* TODO: Map clients to options here */}
                                        {clients.map((client) => (
                                            <option key={client.client_id} value={client.client_id}>{client.name}</option>
                                        ))}
                                    </select>
                                    {selectedClient && <p>You selected: {selectedClient.name}</p>}
                                    </div>
                                </>
                                :
                                <Loader className="spinning"/>
                                }
                            </div>
                            <div>
                                <button onClick={() => {
                                    if (selectedClient || !selectedClient) { //delete the or condition when client selection is implemented
                                        //console.log("tempProject ", tempProject)
                                        //console.log("client ", selectedClient)
                                        updateProject({ ...tempProject, client_id: Number(selectedClient.client_id), client: selectedClient.name })
                                        setShowReassignDialog(false)
                                    }
                                }}>
                                    Save
                                </button>
                                <button 
                                    className="mt-6 px-2 py-1 bg-gray-700 text-xs text-[#ffee00] rounded hoverUp hover:bg-gray-600" 
                                    onClick={() => {
                                        setSelectedClient({name: project.client, client_id: Number(project.client_id)})
                                        setShowReassignDialog(false)
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    } else {
        return (
            <div className="flex justify-center items-center h-screen">
                <h1>Loading Project...</h1>
            </div>
        )
    }
}

export default Project